import PickBeforeGo from "../images/schoolprojects/pickbeforego.png";
import TriangularPegSolitaire from "../images/schoolprojects/triangularpegsolitaire.png";
import Simulator from "../images/schoolprojects/simulator.png";
import TransferConnect1 from "../images/schoolprojects/transfer-connect/TC1.png";
import TransferConnect2 from "../images/schoolprojects/transfer-connect/TC2.png";
import ML1 from "../images/schoolprojects/ML1.png";
import CapstoneDark from "../images/schoolprojects/capstone/capstone_dark.jpg";
import CapstoneLight from "../images/schoolprojects/capstone/capstone_light.jpg";
import CapstoneDarkCropped from "../images/schoolprojects/capstone/capstone_dark_cropped.jpeg";
import CapstoneLightCropped from "../images/schoolprojects/capstone/capstone_light_cropped.jpeg";
import PDopolyPoster from "../images/schoolprojects/pd-opoly/pdopoly_poster.jpg";
import PDopoly2 from "../images/schoolprojects/pd-opoly/pdopoly_2.jpeg";
import PDopoly3 from "../images/schoolprojects/pd-opoly/pdopoly_3.jpeg";
import PDopoly4 from "../images/schoolprojects/pd-opoly/pdopoly_4.jpeg";
import GlucoseConquestKey from "../images/schoolprojects/glucose-conquest/gc_key.png";
import GlucoseConquestPoster from "../images/schoolprojects/glucose-conquest/gc_poster.jpg";
import MindBridge1 from "../images/schoolprojects/mindbridge/mb1.png";
import MindBridge2 from "../images/schoolprojects/mindbridge/mb2.png";
import MindBridge3 from "../images/schoolprojects/mindbridge/mb3.png";
import MindBridge4 from "../images/schoolprojects/mindbridge/mb4.png";
import MindBridge5 from "../images/schoolprojects/mindbridge/mb5.png";
import MindBridge6 from "../images/schoolprojects/mindbridge/mb6.png";
import MindBridge7 from "../images/schoolprojects/mindbridge/mb7.png";
import MindBridge8 from "../images/schoolprojects/mindbridge/mb8.png";
import CS470AI from "../images/schoolprojects/cs470_ai.jpg";
import GuidedByLove from "../images/schoolprojects/guided-by-love.png";
import Deptect from "../images/schoolprojects/deptect.jpg";
import AIHCPoster from "../images/schoolprojects/aihc_poster.jpg";
import Placeholder from "../images/placeholder.png";

export const schoolProjects = [
  {
    id: "prioritisation-echocardiography-requests",
    img: AIHCPoster,
    carouselData: [{ image: AIHCPoster }],
    title: "Prioritisation of Echocardiography Requests",
    year: "Jan 2024 - Apr 2024",
    description:
      "As part of the 01.116 AI for Healthcare module at SUTD, this project was done in collaboration with Sengkang General Hospital. We developed machine learning models to classify and prioritise echocardiogram requests, optimizing resource use and ensuring timely care for critical patients. We engineered 55 features from clinical data, including demographics, clinical history, and lab results. The project achieved a maximum ROC AUC score of 0.672 with LightGBM, identifying key clinical features such as creatinine, troponin levels, and patient age as significant predictors. We used SHAP and LIME for global and local explainability of model predictions.",
    github: "",
    report: "",
    // "https://drive.google.com/file/d/1irHLYSYK3BAyLg5MZgwaH8oFVYFYEbuT/view",
    type: "School",
    youtube: "",
  },
  {
    id: "glowing-guide",
    img: CapstoneDarkCropped,
    carouselData: [
      { image: CapstoneDarkCropped },
      { image: CapstoneDark },
      { image: CapstoneLightCropped },
      { image: CapstoneLight },
    ],
    title: "Glowing Guide - Enhanced Patient Journey at Hospitals",
    year: "Sep 2023 - Apr 2024",
    description:
      "This project was part of the 01.400 Capstone 1 and 01.401 Capstone 2 modules at SUTD, in collaboration with Alexandra Hospital. We aimed to deliver personalised and optimised directional assistance in hospitals by scanning shoeprints and integrating projections with visual redesigns of signage and zones. I supported the team’s efforts in using Amazon Web Services (AWS) for various parts of the project, such as route optimisation, database setup and management, message and queue services, Internet-of-Things cloud service integration, and website hosting. Additionally, I developed a website using React, Tailwind CSS, and AWS Amplify to simulate the proposed patient registration process.\n\nWe were also fortunate to be awarded the 1st Place Faculty Award, and even featured in <a className='text-green dark:text-green-dark underline underline-offset-2' href='https://www.zaobao.com.sg/news/singapore/story20240412-3394837'>Lianhe Zaobao</a>.",
    github: "",
    report:
      "https://capstoneshowcase.sutd.edu.sg/2024/project/proj-s01-alexandra-hospital-enhanced-patient-journey-at-hospitals/",
    type: "School",
    youtube: "https://youtube.com/embed/FBDm0q_BZ24",
  },
  {
    id: "glucose-conquest",
    img: GlucoseConquestKey,
    carouselData: [{ image: GlucoseConquestPoster }],
    title: "Glucose Conquest",
    year: "Sep 2023 - Dec 2023",
    description:
      "As part of the 01.114 Instructional Design of Serious Games for Healthcare module at SUTD, this project was done in collaboration with KK Women’s and Children’s Hospital. We developed a mobile-based virtual pet serious game designed to empower children dealing with Type 1 diabetes. The game mechanics were conceptualised to teach young children about managing their health, including taking glucometer readings and executing insulin injections.",
    github: "",
    report: "",
    // "https://drive.google.com/file/d/1568DNfuM1onj2Tkq4dpHRO-opNIqP6kS/view",
    type: "School",
    youtube: "https://youtube.com/embed/hMIHrGWLh1k",
  },
  {
    id: "guided-by-love",
    img: GuidedByLove,
    carouselData: [],
    title: "Guided by Love: A Caregiver’s Path",
    year: "Sep 2023 - Dec 2023",
    description:
      "In the 02.230TS Health Communication and Behaviour Change module at SUTD, we conceptualised an interactive video designed to enhance understanding and empathy towards the experiences of caregivers, aiming to promote more comprehensive support systems. I contributed to producing a short video trailer to explain the concept and idea.",
    github: "",
    report: "",
    type: "School",
    youtube: "https://youtube.com/embed/IqRcPC-fJDo?si=brAKiSkOoAWZBV7g",
  },
  {
    id: "pd-opoly",
    img: PDopoly3,
    carouselData: [
      { image: PDopolyPoster },
      { image: PDopoly3 },
      { image: PDopoly2 },
      { image: PDopoly4 },
    ],
    title: "PD-opoly",
    year: "Sep 2023 - Dec 2023",
    description:
      "This project was part of the 01.101 Technologies for Sustainable Global Health module at SUTD, in collaboration with the National Kidney Foundation (NKF). We aimed to reduce the knowledge gap of peritoneal dialysis (PD) among tertiary students in Singapore and highlight it as an alternative treatment for kidney failure, fostering wider acceptance of PD in the future. We conceptualised a new flow for NKF’s outreach sessions and developed an interactive Figma prototype for a microsite that provided an enjoyable and immersive learning experience.",
    github: "",
    report: "",
    type: "School",
    youtube: "https://youtube.com/embed/FBq7w5eCxJI",
  },
  {
    id: "mindbridge",
    img: MindBridge1,
    carouselData: [
      { image: MindBridge1 },
      { image: MindBridge2 },
      { image: MindBridge3 },
      { image: MindBridge4 },
      { image: MindBridge5 },
      { image: MindBridge6 },
      { image: MindBridge7 },
      { image: MindBridge8 },
    ],
    title: "MindBridge",
    year: "Feb 2023 - Jun 2023",
    description:
      "As part of the CS374 Introduction to Human-Computer Interaction module at KAIST, we developed MindBridge, a Figma prototype aiming to redesign how working adults manage their mental health and wellbeing in their day-to-day lives. I designed user interfaces for the functional and interactive prototype using Figma, enabling users to tap on existing social connections to encourage self-care and care for themselves like they would a virtual pet.",
    github: "",
    report: "",
    type: "School",
    youtube: "https://youtube.com/embed/bI_3BOX7fu0",
  },
  {
    id: "sterile-instrument-transporter",
    img: CS470AI,
    carouselData: [{ image: CS470AI }],
    title: "Sterile Instrument Transporter",
    year: "Feb 2023 - Jun 2023",
    description:
      "This project was part of the CS470 Introduction to Artificial Intelligence module at KAIST. We developed a proof-of-concept robot to fully automate the distribution of sterilised medical instruments and the sterilisation visual checks in medical facilities. The robot utilised SLAM for mapping hospital blueprints, navigation algorithms for transportation, and anomaly and object detection to scan peel pouches, automating the checking of received inventories.",
    github: "",
    report: "",
    // "https://drive.google.com/file/d/1hATz3oGsHQOh1HZsUsTwotZ-yLx7cdiy/view?usp=drive_link",
    type: "School",
    youtube: "",
  },
  {
    id: "bold-italics-memory",
    img: Placeholder,
    carouselData: [],
    title:
      "A Study on the Effects of Bold and Italics on the Memory of University Students",
    year: "May 2022 - Aug 2022",
    description:
      "As part of the 02.145TS Surveys and Experiments in the Social Sciences module at SUTD, I conducted a literature review to understand relevant related theories and conceptualised and prepared materials for an experiment. The study involved 25 participants and aimed to determine if participants’ comprehension accuracy would be affected by bolding and italics of English passages.",
    github: "",
    report: "",
    type: "Research",
    youtube: "",
  },
  {
    id: "online-hate-speech-detection",
    img: ML1,
    carouselData: [{ image: ML1 }],
    title: "Online Hate Speech Detection",
    year: "May 2022 - Aug 2022",
    description:
      "This project was part of the 50.007 Machine Learning module at SUTD. We trained a variety of machine learning models for online hate speech classification and held a competition on Kaggle amongst all students taking the course. Our group emerged top of the private leaderboard (80% of test data) with an accuracy of 72.399%. Various machine learning methods and techniques to improve model performance, especially those not taught in the course, were attempted, along with extensive hyperparameter tuning. Our best-performing model was the CatBoost Classifier. Other models tried included Random Forest Classifier with PCA, Grid Search and Adaboost, Bernoulli Naive Bayes, Support Vector Machine, Naive Bayes Support Vector Machine, Logistic Regression, LightGBM, and XGBoost.",
    github: "",
    report: "https://www.kaggle.com/competitions/50007-2022/leaderboard",
    type: "School",
    youtube: "",
  },
  {
    id: "transfer-connect",
    img: TransferConnect1,
    carouselData: [{ image: TransferConnect1 }, { image: TransferConnect2 }],
    title: "TransferConnect",
    year: "May 2022 - Aug 2022",
    description:
      "As part of the project was part of the 50.003 Elements of Software Construction module at SUTD, we developed TransferConnect, a full-stack application that acts as the middleman to facilitate the transfer and conversion of loyalty points from bank transactions between participating loyalty programs and banks. For this project, we worked with Ascenda Loyalty.\n\nThe team developed a backend API server and database for TransferConnect, as well as a frontend bank app to demonstrate the end-to-end workflow using the MERN stack (MongoDB, Express, React, Node) and Ant Design Pro. I developed the frontend bank app and wrote some simple frontend tests in Selenium. We used Express.js and Node.js for the backend API server, MongoDB for the database, and Jest for unit testing of the backend.",
    github: "",
    report: "",
    type: "School",
    youtube: "",
  },
  {
    id: "lofi-music-recall",
    img: Placeholder,
    carouselData: [],
    title:
      "A Study on the Effects of Lo-Fi Music on the Ability to Recall Information",
    year: "Jan 2022 - Apr 2022",
    description:
      "As part of the 02.218 Introduction to Psychology module at SUTD, we conducted a study with 40 participants to determine if context specificity would affect participants’ ability to recall and the number of errors in memory reconstruction. I conducted a literature review to understand relevant related theories, and conceptualised and prepared materials for the study.",
    github: "",
    report:
      "https://docs.google.com/presentation/d/1C2r31rh7nWpa3Pd1wC4kG_WPslPociZMj3Qsa9Y57uY/edit?usp=sharing",
    type: "Research",
    youtube: "",
  },
  {
    id: "pick-before-go",
    img: PickBeforeGo,
    carouselData: [{ image: PickBeforeGo }],
    title: "Pick Before Go",
    year: "Jan 2022 - Apr 2022",
    description:
      "As part of the 50.001 Information Systems & Programming module at SUTD, we developed an application in Android Studio to provide Pick & GO shoppers with a revamped experience. The app allowed users to check the availability of products or upcoming promotions while allowing staff to keep track of the current inventory.",
    github:
      "https://github.com/kelliesyhh/SUTD-CSD-Term4-50.001-1DProject-PickBeforeGo",
    report: "",
    type: "School",
    youtube: "https://www.youtube.com/embed/toqGCCv_OMs",
  },
  {
    id: "triangular-peg-solitaire",
    img: TriangularPegSolitaire,
    carouselData: [{ image: TriangularPegSolitaire }],
    title: "Triangular Peg Solitaire",
    year: "Jan 2022 - Apr 2022",
    description:
      "As part of the 50.002 Computation Structures module at SUTD, we implemented the 15-holes triangle configuration of the Peg Solitaire game. The objective is to eliminate pegs until there is only one peg left on the board. To remove pegs, players jump over an adjacent peg into an empty hole, removing the adjacent peg. With 6816 solutions to the game, our implementation breaks down the original game into 3 levels of increasing difficulty. Each level uses 3 colours to provide instant visual feedback with LEDs and the Alchitry Au+ FPGA Development Board.",
    github: "https://github.com/aleextw/50002-1D-ALU",
    report: "",
    type: "School",
    youtube: "https://www.youtube.com/embed/A9H5uWp_qdQ",
  },
  {
    id: "sutd-t1-simulator",
    img: Simulator,
    carouselData: [{ image: Simulator }],
    title: "SUTD Term 1 Simulator",
    year: "Sep 2020 - Dec 2020",
    description:
      "As part of the 10.014 Computational Thinking for Design module at SUTD, this game takes the user through a series of scenarios simulating a Freshmore student’s life through Term 1. Users are randomly assigned a character with initial attribute values for Health, Money, Social, and Intelligence. Throughout the game, the user’s responses determine the final values of their attributes. Scenarios involve questions requiring user input, with attribute values updated based on choices. Some choices activate mini-games, offering bonus opportunities to boost attributes. If any attribute falls below 0, revival questions are activated. Failure to meet revival conditions results in game over. The objective is to survive until the final question, ideally with balanced attribute values indicating a well-rounded individual.",
    github:
      "https://github.com/kelliesyhh/SUTD-Freshmore-Term1-10.014-1DProject",
    youtube: "https://youtube.com/embed/WaYb59SpNLw",
    type: "School",
    report: ""
  },
  {
    id: "depression-detection",
    img: Deptect,
    carouselData: [{ image: Deptect }],
    title: "Depression Detection using Speech Analysis",
    year: "Oct 2018 - Aug 2019",
    description:
      "As part of my Final Year Project, I developed an Android application for depression detection with real-time audio visualisation and machine learning. I developed and optimised a Convolutional Neural Network model for detecting depression and implemented Generative Adversarial Networks to denoise audio data. A Flask web application was implemented using Python to run these models.",
    github: "https://github.com/kelliesyhh/NP-FYP-DepressionDetection",
    type: "School",
    report:
      "https://docs.google.com/document/d/1qiebL6mxpPribZurQ8qpqVndS14cYBUILvrW5Mg09DU/edit?usp=sharing",
    youtube: ""
  },
];